import { FC } from "react";
import { NameIdentifiers } from "../steps";

import { LABEL_CLASSNAME } from "./constants";

type RenderLabelProps = {
  identifier: NameIdentifiers;
  title: string;
  required?: boolean;
  showStar?: boolean;
};

export const RenderLabel: FC<RenderLabelProps> = ({
  identifier,
  title,
  required,
  showStar,
}) => (
  <label htmlFor={identifier} className={LABEL_CLASSNAME}>
    {title} {showStar && required && "*"}
  </label>
);
